export default {
  // 2-12
  GET_INSCHOICE_LIST(state, res) {
    state.ins_choicelist = res.data;
  },
  GET_INSAPPLIER_DATA(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    data.forEach((e, index) => {
      e.index = index + 1;
      e.create_date = e.create_Date.substr(0, 10);
      e.personInfo = `${e.p_Name}(${e.sex})${e.id}`;
      e.period = `${e.insurance_Begin}~${e.insurance_End}`;
      e.approve_Status2 = e.approve_Status;
    });
    state.ins_applier = data;
    state.ins_applierlist = state.ins_applier.slice(0, 10);
  },

  // 2-13
  GET_INSCENSOR_DATA(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    data.forEach((e, index) => {
      e.index = index + 1;
      e.personInfo = `${e.p_Name}(${e.sex})${e.id}`;
    });
    state.ins_forcensor = data;
    state.ins_forcensorlist = state.ins_forcensor.slice(0, 10);
  },
};
